import {fadeIn, fadeOut, hide, slideUp} from '@siteparts/show-hide-effects';

function Dialog(element, windowClass)
{
	this.element = element;
	this.windowClass = windowClass;
	this.isOpen = false;
	this.isModal = false;

	this._create = function () {
		this.window = document.createElement("div");
		this.window.classList.add("webmodel-dialog-window");

		if (this.windowClass) {
			this.window.classList.add(this.windowClass);
		}

		hide(this.window);
		document.body.appendChild(this.window);
		this.window.appendChild(this.element);
	}

	this.open = function () {
		if (this.isOpen) {
			return;
		}

		var self = this;

		if (this.isModal) {
			this.openOverlay();
		}

		fadeIn(this.window, {complete: function () {
			self.isOpen = true;
		}});
	}

	this.close = function () {
		if (!this.isOpen) {
			return;
		}

		var self = this;
		slideUp(this.window, {complete: function () {
			self.isOpen = false;
		}});

		if (this.isModal) {
			this.closeOverlay();
		}
	}

	this.openOverlay = function () {
		var self = this;
		this.overlay = document.createElement("div");
		this.overlay.classList.add("webmodel-dialog-overlay");
		hide(this.overlay);
		this.window.parentNode.insertBefore(this.overlay, this.window);

		// Open/close callbacks
		this.overlay.addEventListener("click", function () {
			self.close();
		});

		fadeIn(this.overlay);
	}

	this.closeOverlay = function () {
		var self = this;
		fadeOut(this.overlay, {complete: function () {
			self.overlay.remove();
		}});
	}

	this.setModal = function (isModal) {
		if (this.isModal == isModal) {
			return;
		}

		this.isModal = isModal;

		if (!this.isOpen) {
			return;
		}

		if (this.isModal) {
			this.openOverlay();
		} else {
			this.closeOverlay();
		}
	}

	this._create();
}

export {Dialog};
